export class MembreContactNotifMuette {
    /**
     * Constructeur de l'objet MembreContactNotifMuette
     * @param row contient les données de l'objet
     */
    constructor(row) {
        if (row) {
            const { idMembreContactNotifMuette, idMembre, idContact } = row;
            this.idMembreContactNotifMuette = idMembreContactNotifMuette;
            this.idMembre = idMembre;
            this.idContact = idContact;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVtYnJlQ29udGFjdE5vdGlmTXVldHRlLmNsYXNzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiTWVtYnJlQ29udGFjdE5vdGlmTXVldHRlLmNsYXNzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sT0FBTyx3QkFBd0I7SUFnQnBDOzs7T0FHRztJQUNILFlBQW1CLEdBQXVDO1FBQ3pELElBQUksR0FBRyxFQUFFO1lBQ1IsTUFBTSxFQUFFLDBCQUEwQixFQUFFLFFBQVEsRUFBRSxTQUFTLEVBQUUsR0FBRyxHQUFHLENBQUM7WUFDaEUsSUFBSSxDQUFDLDBCQUEwQixHQUFHLDBCQUEwQixDQUFDO1lBQzdELElBQUksQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFDO1lBQ3pCLElBQUksQ0FBQyxTQUFTLEdBQUcsU0FBUyxDQUFDO1NBQzNCO0lBQ0YsQ0FBQztDQUNEIn0=